import {
    IMutations,
    IMutationsTemplatePayload,
    IMutationsConceptNotePayload
} from './mutations.types'
import { IWorkspaceData, INotification, IApplication, IConceptNote } from '@/entities'
import { AppConstants as _app } from '@/shared/app.constants'

export const mutations: IMutations = {
    /** set the selected call */
    setSelectedCall(state: IWorkspaceData, payload: number): void {
        state.selectedCall = payload;
    },
    /** set the selected ConceptNote */
    setSelectedConceptNote(state: IWorkspaceData, payload: number): void {
        state.selectedConceptNote = payload;
    },
    /** refresh the state with ConceptNote header info */
    setConceptNote(state: IWorkspaceData, payload: IMutationsConceptNotePayload): void {
        if (!payload.conceptNote.WorkflowInfo) {
            payload.conceptNote.WorkflowInfo = state.conceptNote.WorkflowInfo
        }
        if (!payload.conceptNote.BudgetCurrency) {
            payload.conceptNote.BudgetCurrency = state.conceptNote.BudgetCurrency
        }
        state.conceptNote = payload.conceptNote;
        state.selectedConceptNote = state.conceptNote.ConceptNoteId;
        if (payload.conceptNote["WorkFlowStatusId"])
            state.conceptNote["WorkflowStatusId"] = payload.conceptNote["WorkFlowStatusId"];
    },
    /** set notification */
    setNotification(state: IWorkspaceData, payload: INotification): void {
        state.notification.color = payload.color
        state.notification.snack = payload.snack
        state.notification.text = payload.text
        state.notification.isHtml = payload.isHtml
    },

    /** set the language when switch the language */
    setLanguage(state: IWorkspaceData, payload: string): void {
        state.language = payload
    },

    /** refresh templates while switch the language */
    refreshTemplates(state: IWorkspaceData): void {
        if (state.templates[state.language]) {
            const templateProps = state.templates[state.language].properties;

            Object.keys(templateProps).forEach(key => {
                if (!state[key]) {
                    return; // skip this iteration if state[key] is undefined.
                }
                const appKey = Object.keys(_app.templates).find(k => _app.templates[k] === key);
                if (appKey) {
                    state[key].templates = templateProps[key];

                    if (!state.subMenu[key]) {
                        state.subMenu[key] = Object.keys(state[key].templates.properties)[0]; // set first property as submenu to keep it selected when page is loaded.
                    }
                }
            });
            state.applicationSubmit.templates = state.templates[state.language].properties[_app.templates.submit]
            state.applicationSubmit.checklist = state.checklist;
            if (state.templates[state.language].properties[state.selectedItem])
                state.topMenu = state.templates[state.language].properties[state.selectedItem].title;
        }
    },
    /** update the state with the fetched template */
    setTemplate(state: IWorkspaceData, payload: IMutationsTemplatePayload): void {
        state.templates = payload.templates;
    },

    /** set the sub menu */
    setSubMenu(state: IWorkspaceData, payload: any): void {
        state.subMenu[payload.key] = payload.subMenu;
        if (state.selectedItem === payload.key) {
            window.location.hash = `#${payload.subMenu}`;
        }
    },
    setChecklist(state: IWorkspaceData, payload: any): void {
        state.checklist = payload;
    },
    setLogSchema(state: IWorkspaceData, payload: any): void {
        state.logSchema = payload;
    },
    /** refresh the state with application header info */
    setApplication(state: IWorkspaceData, payload: IMutationsConceptNotePayload): void {
        if (!payload.conceptNote.WorkflowInfo) {
            payload.conceptNote.WorkflowInfo = state.conceptNote.WorkflowInfo
        }
        if (!payload.conceptNote.BudgetCurrency) {
            payload.conceptNote.BudgetCurrency = state.conceptNote.BudgetCurrency
        }
        state.conceptNote = payload.conceptNote;
        state.selectedApplication = state.conceptNote.ConceptNoteId;
        if (payload.conceptNote["WorkFlowStatusId"])
            state.conceptNote["WorkflowStatusId"] = payload.conceptNote["WorkFlowStatusId"];
    },
    // setAppData(state: IWorkspaceData, payload: any) {
    //     state.data = payload

    //     if(state.data && !state.data.additionalDocs){
    //         state.data.additionalDocs = [];
    //     }
    // },
    /** set the indicators */
    setIndicators(state: IWorkspaceData, payload: any): void {
        state.indicators = payload;
    },
    /** clear the application state */
    resetAppState(state: IWorkspaceData): void {
        state.selectedApplication = undefined;
        state.selectedCall = undefined;
        state.templates = {};
        state.conceptNote = {} as IConceptNote;
        state.technicalApplication.data = {};
        state.applicationBudget.data = {};
        state.data = {};
    },
    /** set the selected application */
    //  setSelectedApplication(state: IWorkspaceData, payload: number): void {
    //     state.selectedApplication = payload;        
    // },

    setAppData(state: IWorkspaceData, payload: any) {
        state.data = payload

        if (state.data && !state.data.additionalDocs) {
            state.data.additionalDocs = [];
        }

        if(state.data && !state.data.documents){
            state.data.documents = [{}];
        }

        // update the application state with ES data
        if (state.data) {
            state.conceptNote.LeadPartner = state.data.legalname;
            state.conceptNote.ProjectDuration = state.data.projectDuration;
            state.conceptNote.StartDate = state.data.projectStartDate;
            state.conceptNote.EndDate = state.data.projectEndDate;
            state.conceptNote.RequestedAmount = state.data.fundingRequests ? state.data.fundingRequests : state.data.totalProjectBudgect;
            state.conceptNote.TotalProjectBudget = state.data.totalProjectBudgect;
            state.conceptNote.Country = state.data.countryGrp && state.data.countryGrp.length > 0 ? state.data.countryGrp.map(o => { if (o.country && Object.keys(o.country).length > 0) { return o.country.DisplayText } }).join(', ') : null;
            state.conceptNote.Latitude = state.data.projectSites && state.data.projectSites.length > -1 ? state.data.projectSites.map(o => o.latitude).join(', ') : null;
            state.conceptNote.Longitude = state.data.projectSites && state.data.projectSites.length > -1 ? state.data.projectSites.map(o => o.longitude).join(', ') : null;
        }
    },

    /** set the overlay */
    updateOverlay(state: IWorkspaceData, payload: any): void {
        state.overlay = payload;
    },

    /** set the top menu */
    setTopMenu(state: IWorkspaceData, payload: string): void {
        state.topMenu = payload
        state.selectedItem = payload
        if (state.subMenu[payload]) {
            window.location.hash = `#${state.subMenu[payload]}`;
        }
    },
    resetActiveTabs(state: IWorkspaceData) {
        state.selectedItem = _app.workspace.default_menu;
        state.applicantDueDeligence.selectedKey = _app.workspace.default_due_diligence_key;
        state.technicalApplication.selectedKey = _app.workspace.default_tech_appl_key;
    },

    /** set the application title */
    setTitle(state: IWorkspaceData, payload: string): void {
        state.conceptNote.Title = payload
    },

    /** append custom indicator */
    /** set the selected top menu */
    addIndicator(state: IWorkspaceData, payload: any): void {
        state.indicators.push(payload);
    },

    /** update the indicator */
    updateIndicator(state: IWorkspaceData, payload: any): void {
        var indicator = state.indicators.find(x => x.ID === payload.ID);
        var index = state.indicators.indexOf(indicator);
        state.indicators[index] = payload;
    },

    setPPO(state: IWorkspaceData, payload: any): void {
        state.conceptNote.PrimaryProgramOfficerId = payload.data.PrimaryProgramOfficerId;
    },
}
